import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Login from "../views/Login.vue";
import Post from "../views/Post.vue";
import PostReply from "../views/PostReply.vue";
import PostAdd from "../views/PostAdd.vue";
import PostEdit from "../views/PostEdit.vue";
import ResetPassword from "../views/ResetPassword.vue";
import Categories from "../views/Categories.vue";
import SearchResults from "../views/SearchResults.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/app",
    name: "app",
    beforeEnter() {                    
		window.open("https://app.iamconnected.com", '_self');
	}
  },
  {
    path: "/auth/reset_password/:hash",
    name: "reset_password",
    component: ResetPassword,
    meta: {
		title: "Reset Password"
	}
  },
  {
    path: "/board_sleep",
    name: "board_sleep",
    beforeEnter() {                    
		window.open("https://sleep.iamconnected.com", '_blank');
	}
  },
  {
    path: "/board_meditation",
    name: "board_meditation",
    beforeEnter() {                    
		window.open("https://meditation.iamconnected.com", '_blank');
	}
  },
  {
    path: "/",
    alias: "/dashboard",
    name: "home",
    component: Dashboard,
	meta: {
		title: 'Latest'
	}
  },
  {
    path: "/dashboard/:user_id",
    name: "dashboard",
    component: Dashboard,
    meta: {
		title: 'Latest'
	}
  },
  {
    path: "/login",
    name: "login",
    component: Login,
	meta: {
		title: 'Login'
	}
  },
  {
    path: "/categories",
    name: "category",
    component: Categories,
    meta: {
		title: 'Categories'
	}
  },
  {
    path: "/categories/:slug",
    name: "categories",
    component: Categories,
    meta: {
		title: "Category"
	}
  },
  {
    path: "/post/:post_id",
    name: "post",
    component: Post,
    meta: {
		title: "Post"
	}
  },
  {
    path: "/post_add",
    name: "post_add_no_cat",
    component: PostAdd,
    meta: {
		title: "Add Post"
	}
  },
  {
    path: "/post_add/:slug",
    name: "post_add",
    component: PostAdd,
    meta: {
		title: "Add Post"
	}
  },
  {
    path: "/post_edit/:post_id/:reply_id",
    name: "post_edit",
    component: PostEdit,
    meta: {
		title: "Edit Post"
	}
  },
  {
    path: "/post_reply/:post_id/:post_type/:reply_id",
    name: "post_reply",
    component: PostReply,
    meta: {
		title: "Post Reply"
	}
  },
  {
    path: "/profile",
    name: "profile",
    beforeEnter() {                    
		window.open("https://app.iamconnected.com/profile", '_self');
	}
  },
  {
    path: "/search_results",
    name: "search_results",
    component: SearchResults,
    meta: {
		title: "Search Results"
	}
  },
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;
